
















export default {
    props: {
        title: { type: String, default: 'check icon' },
		fill: { type: String, default: 'currentColor' },
		secondaryfill: { type: String, default: '' }
    }
}
